export const isEmptyObject = (value: Record<string, any>) =>
  Object.keys(value).length === 0;
